import {
  IWorkingDaysAnalyticsActivityV2Enum,
  IWorkingDaysAnalyticsActivityEnum,
} from '../enum/working-days-analytics-activity.enum';
import { ITopAppsReportMapper } from '../interface/top-apps-report-mapper.interface';
import { IAppEnum } from '../enum/app.enum';
import { formatDuration } from '../helpers/duration.helper';
import {
  TopAppsReportResult,
  TopAppsReportV2Result,
} from '../dto/top-apps/cube/mapped/top-apps-report-result.dto';
import {
  TopAppsReportResponseDto,
  TopAppsReportV2ResponseDto,
} from '../dto/top-apps/response/top-apps-report-response.dto';
import {
  TopAppsReportRaw,
  TopAppsReportV2Raw,
} from '../dto/top-apps/cube/raw/top-apps-report.dto';

export class TopAppsReportMapper implements ITopAppsReportMapper {
  persistenceToDomain(model: TopAppsReportRaw): TopAppsReportResult {
    return TopAppsReportMapper.persistenceToDomain(model);
  }
  domainToRest(entity: TopAppsReportResult): TopAppsReportResponseDto {
    return TopAppsReportMapper.domainToRest(entity);
  }
  static persistenceToDomain(model: TopAppsReportRaw): TopAppsReportResult {
    return {
      appId: String(model[IWorkingDaysAnalyticsActivityEnum.AppId]),
      totalDuration:
        Number(model[IWorkingDaysAnalyticsActivityEnum.TotalDuration]) || 0,
      name: String(model[IAppEnum.Name]),
      displayColor: String(model[IAppEnum.DisplayColor]),
      logoUrl: String(model[IAppEnum.LogoUrl]),
    };
  }
  static domainToRest(entity: TopAppsReportResult): TopAppsReportResponseDto {
    const cumulativeAverageDurationDifference =
      entity.cumulativeAverageDurationDifference;
    delete entity.cumulativeAverageDurationDifference;
    return {
      ...entity,
      totalDuration: formatDuration(entity.totalDuration),
      totalDurationVsAvgDurationPercentage:
        cumulativeAverageDurationDifference > 0
          ? `+${cumulativeAverageDurationDifference}`
          : `${cumulativeAverageDurationDifference}`,
    };
  }
}

export class TopAppsReportMapperV2 implements ITopAppsReportMapper {
  persistenceToDomain(model: TopAppsReportV2Raw): TopAppsReportV2Result {
    return TopAppsReportMapperV2.persistenceToDomain(model);
  }
  domainToRest(entity: TopAppsReportV2Result): TopAppsReportV2ResponseDto {
    return TopAppsReportMapperV2.domainToRest(entity);
  }
  static persistenceToDomain(model: TopAppsReportV2Raw): TopAppsReportV2Result {
    return {
      appId: String(model[IWorkingDaysAnalyticsActivityV2Enum.AppId]),
      totalDuration:
        Number(model[IWorkingDaysAnalyticsActivityV2Enum.TotalDuration]) || 0,
    };
  }
  static domainToRest(
    entity: TopAppsReportV2Result
  ): TopAppsReportV2ResponseDto {
    const cumulativeAverageDurationDifference =
      entity.cumulativeAverageDurationDifference;
    delete entity.cumulativeAverageDurationDifference;
    return {
      ...entity,
      totalDuration: formatDuration(entity.totalDuration),
      totalDurationVsAvgDurationPercentage:
        cumulativeAverageDurationDifference > 0
          ? `+${formatDuration(cumulativeAverageDurationDifference)}`
          : `${formatDuration(cumulativeAverageDurationDifference)}`,
    };
  }
}
